import { useCallback, useEffect, useState } from "react";

import { Client } from "../bitmaker/schemas/Billing/Client";

import { useApiError } from "./useApiError";

import { BitmakerAPIClient } from "../services/BitmakerApp";

export function useClient(clientId: string | undefined) {
  const { handleAPIError } = useApiError();

  const [client, setClient] = useState<Client | null>(null);
  const [loadingClient, setLoadingClient] = useState(false);
  const [fetchClientError, setFetchClientError] = useState<string | null>(null);

  const fetchClient = useCallback(() => {
    if (!clientId) {
      setClient(null);
      setFetchClientError(null);
      return;
    }

    setLoadingClient(true);
    setFetchClientError(null);

    BitmakerAPIClient.get(`/billing/clients/${clientId}`, null, (response) => {
      const { isError, message } = handleAPIError(response);

      if (isError) {
        setFetchClientError(
          `Error loading client #${clientId}. Please try again.`,
        );
        console.error("Error fetching client:", message);
        setLoadingClient(false);
        return;
      }

      setClient(response.data as Client);
      setLoadingClient(false);
    });
  }, [clientId, handleAPIError]);

  useEffect(() => {
    fetchClient();
  }, [fetchClient]);

  return {
    client,
    loadingClient,
    fetchClientError,
    refetchClient: fetchClient,
  };
}
